import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PEIInfoSection from '../PEIInfoSection/PEIInfoSection';
import RatesErrorSection from '../RatesErrorSection/RatesErrorSection';
import { getRateInformation } from '../../../../states/ift/selectors';
import { hasError, ratesErrorContentKey } from '../../../../states/rates/selectors';

const mapState = (state) => ({
	rates: getRateInformation(state),
	isError: hasError(state),
	ratesErrorContentKey: ratesErrorContentKey(state),
});
export const RateReviewSection = ({
	rates,
	sendCurrency,
	fromCurrency,
	chargingModal,
	isError,
	ratesErrorContentKey,
}) => (
	<div>
		{!isError && (
			<PEIInfoSection
				rates={rates}
				sendCurrency={sendCurrency}
				fromCurrency={fromCurrency}
				chargingModal={chargingModal}
			/>
		)}
		{isError && <RatesErrorSection contentKey={ratesErrorContentKey} />}
	</div>
);

RateReviewSection.propTypes = {
	rates: PropTypes.shape({}),
	sendCurrency: PropTypes.string.isRequired,
	fromCurrency: PropTypes.string.isRequired,
	chargingModal: PropTypes.string.isRequired,
	ratesErrorContentKey: PropTypes.string.isRequired,
	isError: PropTypes.bool.isRequired,
};
export default compose(connect(mapState))(RateReviewSection);
